var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("yd-table", {
        attrs: {
          loading: _vm.loading,
          "element-loading-text": "正在加载中～",
          pagination: _vm.pages,
          columns: _vm.columns,
          settings: false,
          size: "mini",
          data: _vm.list,
        },
        on: { onChange: _vm.onTableChange },
        scopedSlots: _vm._u([
          {
            key: "orderNo",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "span",
                  {
                    staticClass: "color-mainColor",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.showDetail(row)
                      },
                    },
                  },
                  [_vm._v(_vm._s(row.orderNo))]
                ),
              ]
            },
          },
          {
            key: "type",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "el-tag",
                  { attrs: { type: row.type === 1 ? "primary" : "success" } },
                  [_vm._v(_vm._s(row.type === 1 ? "送机/站" : "接机/站"))]
                ),
              ]
            },
          },
        ]),
      }),
      _c("order-info", { ref: "orderInfoRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }